import React from "react";
import { Icon } from "@iconify/react";
import "./SimplePageBanner.css";

export default function SimplePageBanner({ mainIcon, innerIcon, innerIconStyle, badgeIcon, title, subtitle }) {
  return (
    <section className="cs_simple_banner">
      <span className="cs_simple_banner_dots cs_simple_banner_dots_1" />
      <span className="cs_simple_banner_dots cs_simple_banner_dots_2" />
      <div className="container">
        <div className="cs_simple_banner_row">
          <div className="cs_simple_banner_left">
            <h1>{title}</h1>
            <span className="cs_simple_banner_underline" />
            {subtitle && <p>{subtitle}</p>}
          </div>
          <div className="cs_simple_banner_right">
            <span className="cs_simple_banner_ring" />
            <span className="cs_simple_banner_blob" />
            <Icon icon={mainIcon} className="cs_simple_banner_main_icon" />
            {innerIcon && (
              <Icon
                icon={innerIcon}
                className="cs_simple_banner_inner_icon"
                style={innerIconStyle}
              />
            )}
            {badgeIcon && (
              <span className="cs_simple_banner_badge">
                <Icon icon={badgeIcon} />
              </span>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
